const Alert = ({ type = 'info', message, onClose }) => {
  const styles = {
    success: 'bg-green-50 text-green-800 border-green-200',
    error: 'bg-red-50 text-red-800 border-red-200',
    warning: 'bg-yellow-50 text-yellow-800 border-yellow-200',
    info: 'bg-blue-50 text-blue-800 border-blue-200',
  }

  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
  }

  return (
    <div className={`border rounded-lg p-4 mb-4 flex items-start justify-between ${styles[type]}`}>
      <div className="flex items-start">
        <span className="mr-2 font-bold">{icons[type]}</span>
        <span className="whitespace-pre-line">{message}</span>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className="ml-4 text-lg font-bold hover:opacity-70"
          aria-label="Close"
        >
          ×
        </button>
      )}
    </div>
  )
}

export default Alert
